export default class SessionStoragePop {

    constructor(key, intervalTime) {
        var _self = this;

        // init default values
        _self.sessionKey = key;
        _self.intervalTime = intervalTime;
    }

    /**
     * Update interval Time of current object session
     */
    setIntervalTime(intervalTime) {
        this.intervalTime = intervalTime;
    }

    /**
     *   get Expiration Date
     */
    getExpirationDate(intervalTime) {
        return new Date(new Date().getTime() + 60000 * intervalTime - 10000);
    }

    /**
     *   get current session object
     */
    getJsonObjectFromSession() {
        var jsonObj = JSON.parse(window.sessionStorage.getItem(this.sessionKey));
        return jsonObj;
    }

    /**
     *   get current session object
     */
    removeKey() {
        var _self = this;
        window.sessionStorage.removeItem(_self.sessionKey);
    }
    /**
     * Add Simple Boolean in Session Storage
     */
    addSimpleBooleanInSessionStorage() {
        var _self = this;
        window.sessionStorage.setItem(_self.sessionKey, true);
    }

    /**
     * Update Session Storage
     */
    updateSessionStorage(data) {
        var _self = this;
        window.sessionStorage.setItem(_self.sessionKey, JSON.stringify({
            counterVal: data.counterVal,
            expirationDate: _self.getExpirationDate(_self.intervalTime),
            dateMessage: data.dateMessage,
            message: data.message,
            idAlerte: data.idAlerte,
            closed: data.closed
        }));
    }

    /**
     * Update Counter alone
     */
    updateCounterAlone(val, closed) {
        var _self = this;
        window.sessionStorage.setItem(_self.sessionKey, JSON.stringify({
            counterVal: val,
            expirationDate: _self.getExpirationDate(_self.intervalTime),
            dateMessage: null,
            message: null,
            idAlerte: null,
            closed: closed
        }));
    }

    /**
     * Update Session Storage
     */
    resetCounterInSession() {
        var _self = this;
        window.sessionStorage.setItem(_self.sessionKey, JSON.stringify({
            counterVal: 0,
            expirationDate: _self.getExpirationDate(_self.intervalTime).toISOString(),
            dateMessage: null,
            message: null,
            idAlerte: null,
            closed: false
        }));
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/generic/SessionStoragePop.js